import constantFactory from "@gaoding/constant-factory";

export const { VIEWTYPE1, VIEWTYPE1_LIST, VIEWTYPE1_MAP, VIEWTYPE1_ITEM_MAP } =
  constantFactory("VIEWTYPE1", [
    {
      key: "default",
      label: "瀑布流",
      value: "default",
    },
    {
      key: "fullwidth",
      label: "大图模式",
      value: "fullwidth",
    },
  ]);

export const { VIEWTYPE2, VIEWTYPE2_LIST, VIEWTYPE2_MAP, VIEWTYPE2_ITEM_MAP } =
  constantFactory("VIEWTYPE2", [
    {
      key: "default",
      label: "标准模式",
      value: "default",
    },
    {
      key: "list",
      label: "紧凑模式",
      value: "list",
    },
  ]);
export const { VIEWTYPE3, VIEWTYPE3_LIST, VIEWTYPE3_MAP, VIEWTYPE3_ITEM_MAP } =
  constantFactory("VIEWTYPE3", [
    {
      key: "card",
      label: "标准模式",
      value: "card",
    },
    {
      key: "line",
      label: "单列模式",
      value: "line",
    },
  ]);

export const { VIEWTYPE4, VIEWTYPE4_LIST, VIEWTYPE4_MAP, VIEWTYPE4_ITEM_MAP } =
  constantFactory("VIEWTYPE4", [
    {
      key: "primary",
      label: "标准模式",
      value: "primary",
    },
    {
      key: "list",
      label: "紧凑模式",
      value: "list",
    },
  ]);
